import { Box, Typography } from "@braintrust/braintrust-ui-components";
import { ModalConfirmAsync, ModalInstance } from "@js/components/modal";

type OpenDeleteRosterConfirmModalProps = {
  title: string;
  onConfirm: () => Promise<void>;
};

export const openDeleteRosterConfirmModal = ({
  title,
  onConfirm,
}: OpenDeleteRosterConfirmModalProps) => {
  ModalInstance.open({
    closeButton: false,
    children: (
      <ModalConfirmAsync
        confirmText="Delete"
        confirmButtonVariant="destructive"
        onConfirm={async () => {
          await onConfirm();
          ModalInstance.close();
        }}
        onCancel={ModalInstance.close}
      >
        <Box sx={{ mb: 2 }}>
          <Typography component="h2" variant="title" size="small">
            Delete roster?
          </Typography>
          <Typography component="p" variant="paragraph" sx={{ mt: 1 }}>
            &quot;{title}&quot; will be permanently deleted. This action
            can&apos;t be undone.
          </Typography>
        </Box>
      </ModalConfirmAsync>
    ),
  });
};
